module.exports = __webpack_public_path__ + "img/chem-1.4c383b9c.png";